<template>
  <v-container>
    <List />
  </v-container>
</template>
<script>
import List from "../../components/Company/List.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "CompanyHomeView",
  components: {
    List,
  },
  computed: {
    ...mapGetters({
      getItems: "company/GET_ITEMS",
    }),
    items: {
      get: function () {
        return this.getItems;
      },
    },
  },
  methods: {
    ...mapActions({
      commitTitle: "common/COMMIT_TITLE",
      startRequest: "requestState/START_REQUEST",
      finishRequest: "requestState/FINISH_REQUEST",
      getItemsFromApi: "company/GET_ITEMS_FROM_API",
    }),
  },
  async created() {
    this.commitTitle("Компании");

    this.startRequest("companyList");

    await this.getItemsFromApi();

    this.finishRequest({
      requestName: "companyList",
      success: this.items != null,
    });
  },
};
</script>